document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-direct-payment]').forEach(function (component) {
    var dialog = component.querySelector('[data-direct-payment-dialog]');
    var opener = component.querySelector('[data-direct-payment-open]');
    var closeButtons = component.querySelectorAll('[data-direct-payment-close]');
    var price = component.querySelector('[data-direct-payment-price]');
    var cardPrice = component.querySelector('[data-direct-payment-card-price]');
    var link = component.querySelector('[data-direct-payment-link]');
    var variants = JSON.parse(component.dataset.variants || '[]');
    var productTitle = component.dataset.productTitle;
    var template = component.dataset.messageTemplate;
    var phone = component.dataset.whatsappPhone;

    function formatMoney(cents) {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 2,
      }).format(Math.floor((cents * 96) / 100) / 100);
    }

    function updateVariant(variantId) {
      var variant = variants.find(function (item) {
        return String(item.id) === String(variantId);
      });
      if (!variant) return;

      var discountedPrice = formatMoney(variant.price);
      if (price) price.textContent = discountedPrice;
      if (cardPrice) cardPrice.textContent = discountedPrice;
      var message = template.replace('__PRODUCT__', productTitle).replace('__PRICE__', discountedPrice);
      link.href = 'https://api.whatsapp.com/send/?phone=' + phone + '&text=' + encodeURIComponent(message) + '&type=phone_number&app_absent=0';
    }

    opener.addEventListener('click', function () {
      dialog.showModal();
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    document.addEventListener('change', function (event) {
      if (event.target.name !== 'id') return;
      if (event.target.closest('product-info') !== component.closest('product-info')) return;
      updateVariant(event.target.value);
    });
  });
});
